import { convert } from '../utils'

let lines = [

  {text: ['无论大人还是小孩'],startTime: '00:00:01.00', endTime: '00:00:03.16'},
  {text: ['一走进加利“孩”尼亚的神秘森林'],startTime: '00:00:03.17', endTime: '00:00:06.12'},
  {text: ['就会“咻”的一下缩小'],startTime: '00:00:06.13', endTime: '00:00:08.16'},
  {text: ['变成迷你人'],startTime: '00:00:08.17', endTime: '00:00:10.24'},
  {text: ['这些高高的树干'],startTime: '00:00:11.00', endTime: '00:00:12.19'},
  {text: ['是连接天空之城的梯子'],startTime: '00:00:12.20', endTime: '00:00:15.12'},
  {text: ['动物们老想着到天上去玩'],startTime: '00:00:15.13', endTime: '00:00:18.23'},
  {text: ['所以他们每周都举办比赛'],startTime: '00:00:18.24', endTime: '00:00:22.07'},
  {text: ['看看谁能先爬上去'],startTime: '00:00:22.08', endTime: '00:00:25.06'},
  {text: ['哎哟 掉下来了'],startTime: '00:00:25.07', endTime: '00:00:27.11'},
  {text: ['拍拍屁股再来一次'],startTime: '00:00:27.12', endTime: '00:00:29.20'},



]

export default convert(lines)
